import {getCatalogBtn, handleSubmitCb} from "./helper/helpers";
const userProfileDataTemp = Object.assign(catalogModule.getUserProfile(), {});
const addonsDtUrl = catalogModule.getUrl('user_addons_ex');

const SubscribeButton = (props) => {
    const taxRateForm = "8.100";
    let taxRate = 1.077;
    let product = props.product;
    let type = props.type;
    let price = parseFloat(product.price);
    if (catalogModule.getUserCountry() === "CHE") {
        price *= taxRate;
    }
    price = price.toFixed(2);
    const productButton =  getCatalogBtn();
    let returnButton = type === 'subscription' ?
        <React.Fragment>
            <input type="hidden" name="return" value={addonsDtUrl + '?message=payPal_Return'} />
            <input type="hidden" name="cancel_return" value={addonsDtUrl + '?message=payPal_Cancel'} />
        </React.Fragment>
        :
        <React.Fragment>
            { catalogModule.isAuthenticated() && <input type="hidden" name="return" value={addonsDtUrl + '?message=payPal_Return'} /> }
            { catalogModule.isAuthenticated() && <input type="hidden" name="cancel_return" value={addonsDtUrl + '?message=payPal_Cancel'} /> }
        </React.Fragment>

    function handleSubmit(e) {
        // Check if user has provided his profile
        if(catalogModule.isValidAddress()) {
            showModalPaypal();
        } else {
            if(catalogModule.isAuthenticated()){
                e.preventDefault();
                setUserProfileAddress(null, null, null, null, null, null, null, null, product.key);
            }
        }
    }
    return (
        <React.Fragment>
            <form target="paypal" className="buy_addon_form_class" action={catalogModule.getUrl("paypal_host") + '/cgi-bin/webscr'} method="post" onSubmit={(e) => handleSubmitCb(e, product, showModalPaypal, false)}>
                { userProfileDataTemp.address_line_1 && userProfileDataTemp.address_line_1.length > 0 && <input type="hidden" name="address1" value={userProfileDataTemp.address_line_1} readOnly /> }
                { userProfileDataTemp.address_line_2 && userProfileDataTemp.address_line_2.length > 0 && <input type="hidden" name="address2" value={userProfileDataTemp.address_line_2} readOnly /> }
                { userProfileDataTemp.city && userProfileDataTemp.city.length > 0 &&  <input type="hidden" name="city" value={userProfileDataTemp.city} readOnly /> }
                { userProfileDataTemp.country && userProfileDataTemp.country.length > 0 &&  <input type="hidden" name="country" value={userProfileDataTemp.two_letter_country_code} readOnly /> }
                <input type="hidden" name="email" value={baseBindData.requestUser.email} />
                { baseBindData.requestUser.first_name && baseBindData.requestUser.first_name.length > 0 && <input type="hidden" name="first_name" value={baseBindData.requestUser.first_name} readOnly /> }
                { baseBindData.requestUser.last_name && baseBindData.requestUser.last_name.length > 0 && <input type="hidden" name="last_name" value={baseBindData.requestUser.last_name} readOnly /> }
                { userProfileDataTemp.region && userProfileDataTemp.region.length > 0 && <input type="hidden" name="state" value={userProfileDataTemp.region} readOnly /> }
                { userProfileDataTemp.postal_code && userProfileDataTemp.postal_code.length > 0 && <input type="hidden" name="zip" value={userProfileDataTemp.postal_code} readOnly /> }
                { userProfileDataTemp.phone && userProfileDataTemp.phone.length > 0 &&  <input type="hidden" name="night_phone_a" value={userProfileDataTemp.phone} readOnly /> }
                <input type="hidden" name="cmd" value="_xclick-subscriptions" readOnly />
                <input type="hidden" name="business" value={catalogModule.getUrl("paypal_business")} readOnly />
                <input type="hidden" name="charset" value="utf-8" readOnly />
                {/*<input type="hidden" name="lc" value="CH" />*/}
                <input type="hidden" name="item_name" value={product.name} readOnly />
                <input type="hidden" name="item_number" value={product.key} readOnly />
                <input type="hidden" name="currency_code" value="EUR" readOnly />
                <input type="hidden" name="button_subtype" value="services" readOnly />
                <input type="hidden" name="cn" value="Add special instructions to the seller:" readOnly />
                <input type="hidden" name="no_shipping" value="2" readOnly />
                <input type="hidden" name="rm" value="1" readOnly />
                <input type="hidden" name="shipping" value="0.00" readOnly />
                <input type="hidden" name="bn" value="Xample_Subscribe_WPS_CH" readOnly />
                <input type="hidden" name="notify_url" value={catalogModule.getUrl("paypal_ipn_ex")} readOnly />
                <input type="hidden" name="custom" value={baseBindData.requestUser.id} readOnly />
                <input type="hidden" name="image_url " value={catalogModule.getUrl("ui_new_static") + '/my_xample_logo.png'} readOnly />

                <input type="hidden" name="no_note" value={ type === 'subscription' ? 1 : 0 } readOnly /> {/* if subscribe 1 else 0 */}

                {
                    type === 'subscription' ?
                        <React.Fragment>
                            <input type="hidden" name="a3" value={price} readOnly />
                            <input type="hidden" name="p3" value="1" readOnly />
                            <input type="hidden" name="t3" value="Y" readOnly />
                            <input type="hidden" name="src" value="1" readOnly />
                        </React.Fragment>
                        : ''
                }

                { returnButton }

                { catalogModule.getUserCountry() === "CHE" && <input type="hidden" name="tax_rate" value={taxRateForm} readOnly />  }
                {
                    type === 'subscription' ?
                        <button className={productButton}>{ gettext("Subscribe") }</button>
                        :  <input type="image" src="https://www.paypalobjects.com/en_US/i/btn/sc-but-01.gif" border="0" name="submit" alt="PayPal - The safer, easier way to pay online!" />
                }
                {/*<img alt="" border="0" src="https://www.paypalobjects.com/en_US/i/scr/pixel.gif" width="1" height="1">*/}
            </form>
        </React.Fragment>
    )
};

export default SubscribeButton;
